import { ApiType } from "@gymflow/common";
import { FacilityAvailabilityDTO } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { availabilityQueryKeys } from "./availabilityQueryKeys";

export function useQueryFacilityAvailability(
  {
    api,
    facilityId,
  }: {
    api: ApiType;
    facilityId?: number;
  },
  opts?: Omit<UseQueryOptions<FacilityAvailabilityDTO | null>, "queryKey">,
) {
  const result = useQuery({
    queryKey: availabilityQueryKeys.facilityAvailability(facilityId as number),
    queryFn: async () => {
      const result = await api.availabilityApi.facilityAvailability(
        facilityId as number,
      );
      return result.data;
    },
    enabled: !!facilityId,
    ...opts,
  });

  return result;
}
